"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profaneWords = void 0;
var profane_words_1 = require("./profane-words");
Object.defineProperty(exports, "profaneWords", { enumerable: true, get: function () { return profane_words_1.profaneWords; } });
//# sourceMappingURL=index.js.map